const multiSelectTheme = {
  baseStyle: {
    dropdownContainer: {},
    icon: {},
    multiSelect: {},
    multiSelectOption: {},
    placeholder: {},
    tagContainer: {},
  },
  defaultProps: {
    size: "md",
    variant: "unstyled",
  },
  parts: [
    "dropdownContainer",
    "icon",
    "multiSelect",
    "multiSelectOption",
    "placeholder",
    "tagContainer",
  ],
  sizes: {
    xs: {
      icon: {
        height: "20px",
      },
    },
    sm: {
      icon: {
        height: "28px",
      },
    },
    md: {
      icon: {
        height: "36px",
      },
    },
    lg: {
      icon: {
        height: "44px",
      },
    },
  },
  variants: {
    filled: {
      multiSelect: {
        backgroundColor: "gray.100",
        _hover: {
          backgroundColor: "gray.200",
        },
      },
    },
    flushed: {
      multiSelect: {
        border: "unset",
        borderBottom: "1px solid",
        borderBottomColor: "gray.200",
        borderRadius: "0",
        paddingLeft: "0",
      },
    },
    outline: {
      multiSelect: {
        borderColor: "gray.200",
        _hover: {
          borderColor: "gray.300",
        },
      },
    },
    unstyled: {
      multiSelect: {
        _hover: {
          borderColor: "gray.300",
        },
      },
    },
  },
};

export default multiSelectTheme;
